export default __webpack_public_path__ + "static/media/example3.e1961dfc.svg";